import { ApiBase } from '@/api/api'
import { makePatchRequest } from '@/api/fetchCalls'
import type { ChangeResponseCustomerPayload } from '@/types/response'

export async function changeResponseCustomer(
  responseId: string,
  payload: ChangeResponseCustomerPayload
) {
  await makePatchRequest(`${ApiBase}/response/${responseId}/customer`, {
    body: JSON.stringify(payload),
  })
}
